import { getProgramUserRole, getTeamUserRole } from '@labradorsports/utils';

interface Props {
    team: Team;
    program: Program;
    uid: string;
}

const TeamRole: FC<Props> = ({ team, program, uid }) => {
    return <span className="team-role">{getTeamUserRole(team, uid) ?? getProgramUserRole(program, uid)}</span>;
};

export default TeamRole;
